// Admin entry point — non-obvious URL discourages discovery + indexing.
// Override via /app/frontend/.env: REACT_APP_ADMIN_PATH=/whatever-you-pick
// The default `/secure-console` was chosen over plain `/admin` so that brute
// URL probing (`/admin`, `/admin/login`, `/wp-admin`, etc.) returns the user
// homepage with no leak that an admin app exists.
//
// IMPORTANT: changing this only changes the URL. Real security is enforced
// server-side via /app/backend/rbac.py — every /api/admin/* route validates
// authenticated session + role + permissions.
export const ADMIN_BASE = (process.env.REACT_APP_ADMIN_PATH || "/secure-console").replace(/\/+$/, "");
export const ADMIN_LOGIN_PATH = `${ADMIN_BASE}/login`;
